(() => {
    useIconPicker.$inject = [`iconPickerService`];

    function useIconPicker(iconPickerService) {
        return function ($scope) {
            const state = {
                icons: []
            };
            const resetIcons = iconPickerService.resetIcons;

            const search = (searchTerm) => {
                state.filteredIcons = state.icons.filter((icon) => {
                    if (!searchTerm) {
                        return true;
                    }

                    for (const keyword of icon.keywords) {
                        if (keyword.toLowerCase().includes(searchTerm.toLowerCase())) {
                            return true;
                        }
                    }
                });
            };

            const init = async () => {
                return iconPickerService.getIcons()
                    .then(data => {
                        state.icons = data;
                        state.filteredIcons = [...state.icons];
                        $scope.$digest();
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            };

            return {
                state,
                init,
                search,
                resetIcons
            };
        }
    }

    angular
        .module("harriApp")
        .factory('useIconPicker', useIconPicker);
})();